<template>
  <label class="checkbox-inline mg-left-10" :for="id">
    <input
      type="checkbox"
      :value="value"
      :name="name"
      :id="id"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholder"
      @change="updateInput($event.target.value)"
    >
    <span v-text="label"></span>
  </label>
</template>

<script>
  import inputMixin from './input';

  export default {
    name: 'BlastCheckbox',

    mixin: [
      inputMixin,
    ],
  };
</script>
